import { render, staticRenderFns } from "./goodsInfoCell.vue?vue&type=template&id=497531bf&scoped=true"
import script from "./goodsInfoCell.vue?vue&type=script&lang=js"
export * from "./goodsInfoCell.vue?vue&type=script&lang=js"
import style0 from "./goodsInfoCell.vue?vue&type=style&index=0&id=497531bf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497531bf",
  null
  
)

export default component.exports